/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignRegenerate } from '../../axios/campaignRegenerate'
import type {
	CampaignRegenerateError,
	CampaignRegeneratePathParams,
	CampaignRegenerateRequest,
	CampaignRegenerateResponse,
} from '../../types/CampaignRegenerate'

export const campaignRegenerateMutationKey = () => [{ url: '/campaigns/:campaign/regenerate' }] as const

export type CampaignRegenerateMutationKey = ReturnType<typeof campaignRegenerateMutationKey>

export type CampaignRegenerateVariables = {
	campaign: CampaignRegeneratePathParams['campaign']
	data: CampaignRegenerateRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::regenerate */
export function useCampaignRegenerate<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignRegenerateResponse,
		AxiosError<CampaignRegenerateError>,
		CampaignRegenerateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignRegenerateMutationKey(),
		mutationFn: ({ campaign, data }: CampaignRegenerateVariables) =>
			campaignRegenerate(campaign, data, config).then(res => res.data),
		...options,
	})
}
